// CR Automation API Configuration
const getApiBaseUrl = (): string => {
  const baseUrl = process.env.REACT_APP_CR_AUTOMATION_API_BASE_URL;
  
  if (!baseUrl) {
    throw new Error(
      'REACT_APP_CR_AUTOMATION_API_BASE_URL environment variable is not set. ' +
      'This is required for the application to function. Please set it in your .env file.'
    );
  }
  
  return baseUrl;
};

export const CR_AUTOMATION_API_BASE_URL = getApiBaseUrl();

// CR Automation API Endpoints
export const CR_API_ENDPOINTS = {
  // Equipment - Solar
  MODULE_BRANDS: '/module-brands',
  SOLAR_MODULES: '/solar-modules',

  // Equipment - Inverters
  INVERTER_BRANDS: '/inverter-brands',
  INVERTERS: '/inverters',
  OPTIMIZERS: '/optimizers',
  COMBINERS: '/combiners',
  RSDS: '/rsds',

  // Equipment - Battery
  BATTERY_BRANDS: '/battery-brands',
  BATTERIES: '/batteries',

  // Equipment - Electrical
  MSP: '/msp',
  MSP_BUSS: '/msp/msp-buss',
  MSP_BREAKER: '/msp/msp-breaker',
  MSP_MANUFACTURER: '/msp/msp-manufacturer',
  MSP_LOCATION: '/msp/msp-location',
  MSP_STYLE: '/msp/msp-style',
  MSP_TYPE: '/msp/msp-type',
  MSP_CAD_LOCATION: '/msp/msp-cad-location',

  DISCO: '/disco',
  DISCO_RATINGS: '/disco/ratings',
  DISCO_TYPES: '/disco/types',
  DISCO_BY_RATING_TYPE: '/disco/by-rating-type',
  DISCO_FUSE_RATINGS: '/disco/fuse-ratings',

  POI: '/poi',
  POI_LOCATIONS: '/poi/locations/all',
  POI_LOCATIONS_CREATE: '/poi/locations',
  POI_LOCATIONS_BY_ID: '/poi/:id/locations',
  ATS_BREAKER_SIZES: '/poi/ats-breaker-sizes/all',
  ATS_BREAKER_SIZES_CREATE: '/poi/ats-breaker-sizes',

  CONDUIT: '/conduit',
  CONDUIT_SIZES: '/conduit/sizes',
  CONDUIT_TYPES: '/conduit/types',

  // Equipment - Structural
  STRUCTURAL_OPTIONS: '/structural-options',
  STRUCTURAL_FRAMING_SIZES: '/structural-options/framing-sizes',
  STRUCTURAL_FRAMING_TYPES: '/structural-options/framing-types',
  STRUCTURAL_RAFTER_SPACINGS: '/structural-options/rafter-spacings',

  ATTACHMENTS: '/attachments',
  RAILS: '/rails',

  // Tasks & Reviews
  TASKS: '/tasks',
  ASANA_TASKS: '/asana/tasks',
  CLICKUP_TASKS: '/clickup/tasks',
  CONSTRUCTION_REVIEWS: '/construction-reviews',

  // Building Attributes
  ROOF_TYPES: '/roof',
  ROOF_CONDITIONS: '/roof-condition',
  REROOF_STATUS: '/reroof-status',
  BUILDING_HEIGHTS: '/building-height',

  // Lender Packages
  CLIENTS: '/clients',
  LENDERS: '/lenders',
  LENDER_PACKAGES: '/lender-packages',
  LENDER_PACKAGES_PREVIEW: '/lender-packages/preview',
  NETSUITE_ITEMS: '/netsuite-items',

  // Settings
  SETTINGS: '/settings'
} as const

// HTTP Status Codes
export const HTTP_STATUS = {
  UNAUTHORIZED: '401',
  FORBIDDEN: '403',
  NOT_FOUND: '404',
  BAD_GATEWAY: '502',
  SERVICE_UNAVAILABLE: '503',
} as const

// Prefix of the errors apiService throws for non-2xx responses: "HTTP Error: <status> <statusText>"
export const API_HTTP_ERROR_PREFIX = 'HTTP Error:'

// HTTP Methods
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE'
} as const

// Query Parameters
export const QUERY_PARAMS = {
  BRAND_ID: 'brandId',
  SEARCH: 'search',
  STATUS: 'status'
} as const

// Status Filter Values
export const STATUS_FILTER_VALUES = {
  ALL: 'all',
  ACTIVE: 'active',
  INACTIVE: 'inactive'
} as const

// Search Configuration
export const SEARCH_CONFIG = {
  MIN_SEARCH_LENGTH: 3,
  DEBOUNCE_DELAY: 300,
  MAX_RESULTS: 10
} as const

// Request Timeout Configuration (in milliseconds)
export const REQUEST_TIMEOUT = {
  DEFAULT_MS: 30_000,
} as const
